import axiosClient from "@/shared/lib/axios/axios";
import { ApiResponse } from "@/shared/types/api";
import { API_ROUTES } from "../config";
import type { CycleDetail } from "../../types/cycle";

export const getCycleDetail = async (cycleUuid: string): Promise<CycleDetail | null> => {
  const res = await axiosClient.get<ApiResponse<CycleDetail>>(
    `${API_ROUTES.CYCLE_DETAIL}${cycleUuid}/`
  );
  return res?.data?.data ?? null;
};
